import { render } from "./NzmTestReport.vue?vue&type=template&id=b0489136&scoped=true&ts=true"
import script from "./NzmTestReport.vue?vue&type=script&lang=ts"
export * from "./NzmTestReport.vue?vue&type=script&lang=ts"

import "./NzmTestReport.vue?vue&type=style&index=0&id=b0489136&scoped=true&lang=css"
import "./NzmTestReport.vue?vue&type=style&index=1&id=b0489136&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0489136"]])

export default __exports__